/**
 * redirectToCurrentSearchMap: when the user grants NewHomeSource access to their current location,
 * this function receives the location information. if we have a valid location
 * the site performa a redirect to the search map in the search result page.
 * @param latitude - representing the user's current position in terms of navigator.geolocation API.
 * @param longitude - representing the user's current position in terms of navigator.geolocation API.
 */
const redirectToCurrentSearchMap = function (latitude, longitude) {
    const deviceHeight = window.innerHeight;
    const deviceWidth = window.innerWidth;
    /*
     * Convert the device width (in pixels) into the number of tiles.
     * Since there are 256 tiles horizontally at zoom level 9,
     * divide the device width by 256 to get the number of tiles across the width of the map.
     */
    const tilesAcrossWidth = deviceWidth / 256;
    /*
     * Calculate the horizontal span of the map in degrees. At zoom level 9,
     * each tile covers a specific range of longitudes.
     * You can calculate the width of a single tile in degrees by dividing
     * the total longitude range (360 degrees) by the number of tiles (256).
     */
    const degreesPerTile = 360 / 256;
    /*
     * Calculate the maximum and minimum longitude values based on the
     * center point and the number of tiles across the width of the map.
     */
    const maxLongitude = + longitude + (tilesAcrossWidth / 2) * degreesPerTile;
    const minLongitude = + longitude - (tilesAcrossWidth / 2) * degreesPerTile;
    /*
     * The latitude span depends on the aspect ratio of the map.
     * To calculate the maximum and minimum latitude values, you need to know the aspect
     * ratio of your map view (height divided by width). The latitude span is calculated
     * by multiplying the longitude span by the aspect ratio.
     */
    const aspectRatio = deviceHeight / deviceWidth;
    const maxLatitude = + latitude + (tilesAcrossWidth / 2) * degreesPerTile * aspectRatio;
    const minLatitude = + latitude - (tilesAcrossWidth / 2) * degreesPerTile * aspectRatio;
  
    window.open(`/communities/map?coordinates=${minLatitude},${minLongitude},${maxLatitude},${maxLongitude}`, '_blank');
};

/**
 * handleLocationPermissionGranted: when the user grants NewHomeSource access to their current location,
 * this function receives the location information. If the user's location is within the United States of America,
 * the map center will adjust to the user's current location."
 * @param geolocation - object representing the user's current position in terms of navigator.geolocation API.
 */
const handleLocationPermissionGranted = async (geolocation) => {
    sessionStorage.setItem('geolocationPermission', true);
    redirectToCurrentSearchMap(geolocation.coords.latitude, geolocation.coords.longitude)
}

/**
 * handleLocationPermissionDenied: when the user dennies NewHomeSource access to their current location,
 * this function handles the next steps to follow like showing an information message indicating that
 * permissions where not granted.
 */
const handleLocationPermissionDenied = () => {
    sessionStorage.setItem('geolocationPermission', false);
    const errorContainer = document.querySelector('[data-current-location-permission-denied-error]');
    const searchInput = errorContainer.closest('form');

    searchInput.classList.add('error');
    errorContainer.style.display = 'block';
}

/**
 * getCurrentLocation: Requests permission from the user to access their current location and executes
 * a callback for both granted and denied permission scenarios.
 */
const redirectToCurrentLocation = function () {
    navigator.geolocation.getCurrentPosition(handleLocationPermissionGranted, handleLocationPermissionDenied);
}

export default redirectToCurrentLocation;
